import type { ComponentProps } from 'react';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Breadcrumb } from '@sorare/core/src/components/breadcrumb';

import { Search } from 'components/Search';

type Props = {
  sections?: ComponentProps<typeof Breadcrumb>['sections'];
};

export const Header = ({ sections }: Props) => {
  return (
    <Vertical>
      <SBHorizontal>
        <Breadcrumb sections={sections} withPadding />
      </SBHorizontal>
      <Search />
    </Vertical>
  );
};
